import { render, staticRenderFns } from "./WorkingHours.vue?vue&type=template&id=04aa3991&scoped=true&"
import script from "./WorkingHours.vue?vue&type=script&lang=js&"
export * from "./WorkingHours.vue?vue&type=script&lang=js&"
import style0 from "./WorkingHours.vue?vue&type=style&index=0&id=04aa3991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa3991",
  null
  
)

export default component.exports